module.exports = __webpack_public_path__ + "static/media/0254_Medium.4b15719e.jpg";